import { getSiteDomain } from '../utils/common';
import makeRequest from './makeRequest';

export default function fetchExperimentRhs() {
  const { data, gaPrefix, theme } = this.props.sidebarData;
  const sidebarAdArray =
    Array.isArray(data) &&
    data.length > 0 &&
    data
      .filter(item => item.tn === 'ad' && item.rhsPos !== 5)
      .map((currentAd, index) => ({
        ...currentAd,
        divId: `${currentAd.divId}-${index}`,
      }));
  const dataUrl = `${getSiteDomain()}/testsidebardata_csr.cms?feedtype=json&msid=${
    this.props.msid
  }`;
  makeRequest.get(dataUrl, {}, 'skipfeedengine').then(result => {
    if (result && result.data && result.data.length > 0) {
      //console.log('data : ', data.data);
      sidebarAdArray.forEach((aditem, index) => {
        if (index === 0) {
          result.data.unshift(aditem);
        } else if (index === 1) {
          result.data.splice(2, 0, aditem);
        } else if (index === 2) {
          result.data.splice(result.data.length - 1, 0, aditem);
        }
      });
      const expSidebarData = {
        gaPrefix,
        theme,
        data: [...result.data],
      };
      this.setState({
        experimentSidebarData: expSidebarData,
      });
    }
  });
}
